import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
export const ServicePackageCardElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  methods: {
    getExampleEntity() {
      return {
        "expert_service_package_id": 1,
        "name": "Test Service Package",
        "description": "Test Description",
        "price": 99.99,
        "org_id": 1,
        "contract_id": 1,
        "status": "active",
        "timestamp_created": 1733412192,
        "timestamp_updated": 1733412192,
      };
    },
    getRealEntity() {
      return this.getExampleEntity();
    },
  },
};
